import PropTypes from 'prop-types';
import {issueModelType} from './issue-proptypes';
import {ISSUES_SORTED_STATUSES, QUALITY_ISSUES_SORTED_STATUSES} from '../status-types';
import {TYPE_ISSUES, TYPE_QUALITY_ISSUES} from '../issue-types';

const issuePushpinStatuses = ISSUES_SORTED_STATUSES.reduce((results, status) => {
  results.push(`${TYPE_ISSUES}-${status}`);
  return results;
}, []);

const qualityIssuePushpinStatuses = QUALITY_ISSUES_SORTED_STATUSES.reduce((results, status) => {
  results.push(`${TYPE_QUALITY_ISSUES}-${status}`);
  return results;
}, []);

const pushpinStatusType = PropTypes.oneOf([...issuePushpinStatuses, ...qualityIssuePushpinStatuses]);

export const activePushpinAttributesType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    z: PropTypes.number.isRequired
  }),
  status: pushpinStatusType.isRequired,
  type: issueModelType,
  objectId: PropTypes.number,
  viewerState: PropTypes.object,
  externalId: PropTypes.string,
  attributesVersion: PropTypes.number,
  // used to clear newly-dropped pushpin:
  isNew: PropTypes.bool
});
